// src/utils/firebase/features/invitations/writers.js
import { collection, doc, setDoc } from "firebase/firestore";
import { getDbOrThrow } from "../../core/firestoreCore";
import { COLLECTIONS } from "../../core/collections";

/**
 * Submit a beta invite request for a public (logged-out) user.
 * Accepts either a string email or an <input> element / event.target with .value.
 */
export async function submitBetaInviteRequest(emailRaw) {
  // Safely extract a string from various caller shapes
  const picked =
    typeof emailRaw === "string"
      ? emailRaw
      : emailRaw?.value ?? emailRaw?.target?.value ?? emailRaw?.currentTarget?.value ?? "";

  const email = String(picked || "").trim().toLowerCase();
  if (!email) throw new Error("Email required");

  const db = getDbOrThrow();
  const colRef = collection(db, COLLECTIONS.systemBetaInvitations);
  const ref = doc(colRef, email);

  const payload = {
    email,
    pp_invitation_key: "",
    approved: false,
    approved_timestamp: null,
  };

  await setDoc(ref, payload, { merge: true });
  return true;
}
